// extracted by mini-css-extract-plugin
export var fullHeightState = "_5w-7";
export var headerCell = "_5w-1";
export var loadingStateCell = "_5w-4";
export var rowWrapper = "_5w-3";
export var standaloneTable = "_5w-8";
export var standaloneTableWithBodyFill = "_5w-9";
export var stateCell = "_5w-5";
export var table = "_5w-0";
export var tableBodyFiller = "_5w-6";
export var white = "_5w-2";